import React from 'react';
import logofooter from '../../images/new_logo.png';
import fadedbg from '../../images/fade-footer-img.svg';
import { Link } from 'react-router-dom';

import "./Footer.css";
function FooterComponent() {
    return (
        <>
            <section className='seven'>
                <div className='container text-center'>
                    <div className='footer-content'>
                        {/* <div className='logo-footer'>
                            <img src={logofooter} alt="footer-logo"></img>
                        </div> */}
                        <div className="logo">
                            <Link to="/">
                                <img src={logofooter} alt="logo" />
                            </Link>
                        </div>
                        {/* <p>HOA Verified enables homeowners' associations to quickly comply with Florida's new HB 59, which mandates the provision of homeowners' rules and covenants. Additionally, we offer an enhanced feature for private communication with resident members, ensuring complete transparency.</p> */}
                        <div className='footer-list'>
                            <div className='list-text' onClick={() => window.scrollTo(0, 0)}><Link to="/">Home</Link></div>
                            <div className='vertical-line'></div>
                            {/* <div className='list-text'><Link to="/">About Us</Link></div> */}
                            {/* <div className='vertical-line'></div> */}
                            <div className='list-text'><Link to="/Hoa">HOAs</Link></div>
                            <div className='vertical-line'></div>
                            <div className='list-text'><Link to="/RealtorsBrokerages">Realtors & Brokerages</Link></div>
                            <div className='vertical-line'></div>
                            <div className='list-text'><Link to="/Contact">Contact</Link></div>
                            <div className='vertical-line'></div>
                            <div className='list-text'><Link to="/login">Login</Link></div>
                        </div>
                        <div className='terms-conditions'>
                            <div className='list-text'><Link to="/terms-of-service">Terms of Service</Link></div>
                            <div className='vertical-line'></div>
                            <div className='list-text'><Link to="/privacy-policy">Privacy Policy</Link></div>
                        </div>
                    </div>
                </div>
                <div className='fade-bg'>
                    <img src={fadedbg} alt="Footer-background"></img>
                </div>
                <div className='fade-bg-right'>
                    <img src={fadedbg} alt="Footer-background"></img>
                </div>
                <div className='container text-center'>
                    <div className='footer-line'></div>
                </div>
                <div className='container text-center'>
                    <p className='copyright'>
                        Copyright {new Date().getFullYear()} - HOA Verified Corporation
                    </p>
                </div>
            </section>
        </>
    );
}

export default FooterComponent;